var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_112_616)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_112_616",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_112_616",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_112_616",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB70lEQVR4nO3dPU7DMByG8UzAEfrBEQtspDfgPkw9AR8TcAl2VAYyvShSkAC5kh01rxv7+UldUGX+fRS5yINpGgAAAAAAAPwh6VzStaRnSZ+av09JT5Ku+s/WnAJJl5LeVK4XSevckS8Kj/w7dr4nW9KN6rHJGbrfk2vxmDP0XvXY5wxdlYbQHoQ2IbQJoU0IbUJoE0KbENpkTqE7SbeSVsOrHX52yNfP+484c8zvnX3oNrBG/6EPuZ1w9rbk0MvAGouU9x9x9kXJoVeBNdaZQq9r2zq2mbaObcmhu2Fv5MswceiqNIT2ILQJoU0IbUJoE0KbENqE0CZzCt1xTDpu6FRtYA2OSSOGTbUMrMExacSwqVaBNTgmjRg2VRtYg2PSiGFTdRyTjhu6Kg2hPQhtQmgTQpsQ2oTQJoQ2IbTJnEJ3HJOOGzpVG1iDY9KIYVMtA2twTBoxbKpVYA2OSSOGTdUG1uCYNGLYVB3HpOOGrkpDaA9CmxDahNAmhDYhtAmhTQhdQeiarmP7yBmaCwYdhht2a7HJfZ3xq+q4BPYsW+hf1xqXHPsl+7XG/57s/lLrx0K+IPeSHvrtIvuTPCVJZ5LuRwTa9Xda556/9Ng7Ik8fm8iG2DsiTx97R+Rp/rK5k/Q+vO5O5l93AAAANKfiG8/gitzuslc1AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupActive);
export default __webpack_public_path__ + "static/media/Popup-active.0128d62db75c432aa7c482f7bb980726.svg";
export { ForwardRef as ReactComponent };